module.exports = __webpack_public_path__ + "img/gotemplate.766bc46d.svg";